import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmAction } from 'app/shared/constants';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  title: string = '';
  message: string = '';
  primaryButtonText: string = '';
  secondaryButtonText: string = '';
  thirdButtonText: string | null = null;
  isHTML: boolean = false;
  showCloseButton = true;
  showCancelButton = true;
  showPrimaryButton = true;

  get primaryButtonLabel(): string {
    if (this.primaryButtonText) {
      return this.primaryButtonText;
    }
    return this.translate.instant('BUTTONS.CONFIRM');
  }

  get secondaryButtonLabel(): string {
    if (this.secondaryButtonText) {
      return this.secondaryButtonText;
    }
    return this.translate.instant('BUTTONS.CANCEL');
  }

  constructor(
    private dialogRef: DynamicDialogRef,
    { data }: DynamicDialogConfig,
    private translate: TranslateService,
  ) {
    if (data.title) this.title = data.title;
    if (data.message) this.message = data.message;
    if (data.primaryButtonText) this.primaryButtonText = data.primaryButtonText;
    if (data.thirdButtonText) this.thirdButtonText = data.thirdButtonText;
    if (data.isHTML) this.isHTML = data.isHTML;
    if (data.showCloseButton != null) this.showCloseButton = data.showCloseButton;
    if (data.showCancelButton != null) this.showCancelButton = data.showCancelButton;
    if (data.showPrimaryButton != null) this.showPrimaryButton = data.showPrimaryButton;
  }

  closeDialog(value: ConfirmAction | null) {
    this.dialogRef.close(value);
  }
}
